import { Trash2 } from "lucide-react";

/** Themed trash well for delete / confirm modals (replaces deleteIcon.svg circle). */
export default function DeleteModalIcon() {
  return (
    <div className="qv-delete-modal-icon-well" aria-hidden="true">
      <Trash2 strokeWidth={1.75} />
    </div>
  );
}
